import DropdownMenu from '@/common/components/DropdownMenu'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useResetGovernmentAllocationDistributions } from '@/features/governmentAllocations/hooks/useResetGovernmentAllocationDistributions'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

export const GovernmentAllocationOptions = () => {
  const { id: governmentAllocationId } = useParams()
  const queryClient = useQueryClient()

  const [isZeroDistributionOpen, setIsZeroDistributionOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const handleZeroDistribution = () => {
    resetGovernmentAllocationDistributions()
  }

  const {
    mutate: resetGovernmentAllocationDistributions,
    isPending: resetGovernmentAllocationDistributionsIsPending,
    isError: resetGovernmentAllocationDistributionsIsError,
  } = useResetGovernmentAllocationDistributions({
    governmentAllocationId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions', governmentAllocationId] })
      queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation', governmentAllocationId] })
      setIsZeroDistributionOpen(false)
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setMessages(error.response?.data.errors.base)
      } else {
        setMessages(['Erro ao zerar distribuições. Tente novamente.'])
      }
    },
  })

  return (
    <>
      <DropdownMenu
        triggerClassName="bg-blue-700 hover:bg-blue-500"
        triggerLabel="Opções do empenho"
        itemClassName="min-w-[200px]"
        options={[
          {
            label: "Zerar distribuições",
            onClick: () => {
              setIsZeroDistributionOpen(true);
            },
          },
        ]}
      />

      <Modal
        isOpen={isZeroDistributionOpen}
        setIsOpen={setIsZeroDistributionOpen}
        useCancellableFooter
        confirmButtonText={
          resetGovernmentAllocationDistributionsIsPending
            ? "Zerando distribuições..."
            : "Zerar distribuições"
        }
        cancelButtonText="Cancelar"
        onConfirm={handleZeroDistribution}
        onCancel={() => setIsZeroDistributionOpen(false)}
        confirmButtonIsLoading={resetGovernmentAllocationDistributionsIsPending}
        disabled={resetGovernmentAllocationDistributionsIsPending}
        bodyClassName="bg-neutral-op-8"
        body={
          <div className="text-white-800 rounded-md">
            <h1 className="text-white-800 font-bold text-2xl mb-2">
              Zerar distribuições?
            </h1>
            <p className="mb-4">
              Isso vai remover todos os valores distribuídos deste empenho.
            </p>
            <p>
              Até que o gestor redistribua, nenhum equipamento ou serviço poderá
              consumir recursos deste empenho.
            </p>
          </div>
        }
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={resetGovernmentAllocationDistributionsIsError}
        />
      )}
    </>
  );
}
